import Cookies from 'universal-cookie';
import SUPPORTED_LOCALES from 'constants/locales';
import moment from 'moment';
import { getParam } from './ebUtils';
import getCASToken from './getCASToken';
import './momentTimezoneData';

export { useAction } from './useAction';
export { loadRemoteManifest } from './loadRemoteComponent';
export { orgId, Ajax, redirectToLogin, redirectToLoginWithOrigin, commsId } from './Ajax';
export { FieldValidation } from './FieldValidation';
export { getUrlParams, formatLocalDate } from './ebUtils';
export const isCommsDetail = !!window.location.pathname.match(/\/comms\//)

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const clientTimeZone = moment.tz.guess();
const cookies = new Cookies();
const { protocol, host, search } = window.location;
const contactIdPrivate = getParam('contactId');
const FE_VERSION = '25.5.0.9912addd';
const baseUrl = `${protocol}//${host}`;
const memberAppSignup = search.includes('from=member_signup');
const memberApp = search.includes('from=member') && !memberAppSignup;
const queryParam = name => qs.parse((window.location.search || '?').slice(1))[name] || '';
const setPageTitle = name => {
  const formattedTitle = name.trim().replace(/\s+/g, ' ');
  if (document.title === formattedTitle) {
    return null;
  }
  const resetFocus = document.getElementById('resetFocus');
  if (document.activeElement !== document.body && resetFocus) {
    setTimeout(() => {
      window.scrollTo(0, 0);
      resetFocus.focus();
    }, 10);
  }
  document.title = formattedTitle;
  return null;
};
const timeout = ms => new Promise(res => setTimeout(res, ms));
const random = () => (+new Date()).toString(36).slice(-6);
const getI18nUrl = (lang) => `/public/i18n/${lang}.json?version=${FE_VERSION}`;

const convertHTMLTags = (value) => {
    const dict = {
      // put '&' on top to convert '&' first
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
    }
    if (typeof value === 'string') {
      return Object.keys(dict).reduce((prev, curr) => {
        return prev.replace(new RegExp(curr,'g'), dict[curr])
      }, value)
    } else {
      return value
    }
  }

const getFromLocal = (name) => {
  if (window.localStorage) {
    window.localStorage.setItem('null', 'null');

    return window.localStorage.getItem(name) || '';
  }

  return '';
};

// const linkRegex = /(<(a[^>]*)>(.*?)<\/a>)|((([A-Za-z]{3,9}:(?:\/\/))(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:[wW]{3}\.)[A-Za-z0-9]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/
const linkRegex = /(?:<(a[^>]*)>(.*?)<\/a>)|((?:[A-Za-z]{3,9}:\/{2})(?:[\-;:&=\+\$,\w]+@)?(?:[A-Za-z0-9\-\.])*)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))|(?:[wW]{3}\.)[A-Za-z0-9]+(?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*)?/

const qs = ()=>{
  const query = Object.fromEntries(new URLSearchParams(window.location.search));
  return query;
}

export {
  qs,
  clientTimeZone,
  cookies,
  getCASToken,
  SUPPORTED_LOCALES,
  protocol,
  host,
  baseUrl,
  queryParam,
  contactIdPrivate,
  memberApp,
  FE_VERSION,
  setPageTitle,
  timeout,
  random,
  getI18nUrl,
  convertHTMLTags,
  linkRegex,
  getFromLocal
};
